import { gql } from "@apollo/client";

export const AssetNameplateBasicInfo = gql`
    query AssetNameplateBasicInfo ($id: ID!, $imageCrop: ResizeCrop, $imageWidth: Int, $imageHeight: Int) {
        assetLocation (id: $id) {
            id
            owner {
                id
                industryType
            }
            installedBaseNode {
                id
                key
                title
                access {
                    id
                    write
                }
                image {
                    id
                    file {
                        id
                        thumbnailLink (crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                    }
                }
            }
            asset {
                id
                urn
                serialNumber
                product {
                    id
                    name
                    productCode
                    iotConfiguration {
                        id
                    }
                    manufacturer {
                        id
                        name
                    }
                    image {
                        id
                        thumbnailLink (crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                    }
                }
            }
        }
    }
`;
